type ReplaceMap = Record<string, string | undefined>;

/** Deeply replaces all {placeholders} in string values of the input */
export function deepReplacePlaceholders<T>(input: T, replacements: ReplaceMap): T {
    if (Array.isArray(input)) {
        return input.map((item) => deepReplacePlaceholders(item, replacements)) as T;
    }
    if (input && typeof input === 'object') {
        const result: any = {};
        for (const [key, value] of Object.entries(input)) {
            result[key] = deepReplacePlaceholders(value, replacements);
        }
        return result;
    }
    if (typeof input === 'string') {
        return input.replace(/{(\w+)}/g, (_, key) => replacements[key] ?? `{${key}}`) as T;
    }
    return input;
}
